export const validateEmptyValue = (obj: string | number, excludeZero?: Boolean) => {
    const message = 'This field is required';
    if (obj === undefined || obj === '' || obj === null) {
        return message;
    }

    return undefined;
};



// WEBPACK FOOTER //
// ./src/helpers/Validations/validateEmptyValue.ts